module.exports = __webpack_public_path__ + "media/images/haircut/laura@3x-bf42f5f571c0a0be082be2c4062a18d6.jpg";